import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {
  createRiskAssessment,
  deleteRiskAssessment,
  editRiskAssessment,
  getAllRiskAssessments,
  getRiskAssessments,
} from '../../../../../redux/risk-assessment/riskAssessmentSlice';
import {useSelector} from 'react-redux';
import {
  getRiskAssessmentLoadingState,
  getRiskAssessmentStateSelector,
} from '../../../../../redux/selectors/riskAssessment';
import Button from '../../../../../components/form/button/button';
import NewRiskAsessment from '../../components/new-risk-assessment/newRiskAsessment';
import NewCybersecurityAssessment from '../../components/new-cybersecurity-assessment/newCybersecurityAssessment';
import RiskAssessmentCard from '../../components/risk-assessment-card.js/risk-assessment-card';
import ImportRiskAssessment from '../../components/import-risk-assessment/importRiskAssessment';
import ImportFunctionalSafety from '../../components/import-functional-safety/importFunctionalSafety';
import {allRoutes} from '../../../../../utils/routeConstants';
import {getLoginStateSelector} from '../../../../../redux/selectors/loginSelector';
import {
  assessmentTypeIds,
  assessmentTypeNames,
  rbac,
  riskAssessmentAccessIds,
  riskAssessmentAccessNames,
  taskStatusIDS,
} from '../../../../../utils/constants';
import Confirmation from '../../../../../components/confirmation/confirmation';
import './riskAssessment.scss';
import Loader from '../../../../../components/loader/loader';
import CustomSearch from '../../../../../components/custom-search/customSearch';
import {toast} from 'react-toastify';
import {assets} from '../../../../../utils/assetsSrc';

export default function RiskAssessment() {
  const [riskAssessmentModels, setRiskAssessmentModels] = useState([]);
  const [heading, setHeading] = useState('');
  const [showConfirmationPopUp, setShowConfirmationPopUp] = useState(false);
  const [
    showConfirmationForSubmitRequestPopUp,
    setShowConfirmationForSubmitRequestPopUp,
  ] = useState(false);
  const [showCreateNewRiskAssessment, setShowCreateNewRiskAssessment] =
    useState(false);
  const [
    showCreateNewCybersecurityAssessment,
    setShowCreateNewCybersecurityAssessment,
  ] = useState(false);
  const [showDuplicateRiskAssessment, setShowDuplicateRiskAssessment] =
    useState(false);
  const [showEditRiskAssessment, setShowEditRiskAssessment] = useState(false);
  const [showImportRiskAssessment, setShowImportRiskAssessment] = useState(false);
  const [showImportFunctionalSafety, setShowImportFunctionalSafety] = useState(false);
  const [clickedRiskAssessment, setClickedRiskAssessment] = useState({});
  const [selectedRiskAssessmentDetails, setSelectedRiskAssessmentDetails] =
    useState({});
  const [riskAssessmentConfig, setRiskAssessmentConfig] = useState({
    params: {search: ''},
  });
  const isLoading = useSelector(getRiskAssessmentLoadingState());
  const location = useLocation();
  const dispatch = useDispatch();
  const nav = useNavigate();
  let searchTimer;
  const riskAssessmentState = useSelector(getRiskAssessmentStateSelector());
  const userRoleId = useSelector(getLoginStateSelector())?.loggedInUser?.role;
  const modelId = location.state?.selectedModelId;

  const [type, setType] = useState(null);

  useEffect(() => {
    // All risk Assessments for a product line
    const productLineId = location.state?.selectedProductLine?.id;
    const modelId = location.state?.selectedModelId;
    //assessment type
    const assessmentType = location?.state?.type;
    if (assessmentType) setType(assessmentType);
    if (modelId) {
      fetchRiskAssessments({
        modelId,
        type: assessmentType,
        riskAssessmentConfig,
      });
    } else if (productLineId) {
      fetchRiskAssessments({
        productLineId,
        type: assessmentType,
        riskAssessmentConfig,
      });
    }
    fetchProductLineAllRiskAssessments({productLineId, riskAssessmentConfig});
  }, [location, riskAssessmentConfig]);

  useEffect(() => {
    const modelList = riskAssessmentState
      .map(item => item.machine_detail)
      .flat(1);
    const uniqueModelList = [
      ...new Map(modelList.map(item => [item['name'], item])).values(),
    ];
    if (modelId)
      setRiskAssessmentModels(
        uniqueModelList.filter(item => item.id == modelId),
      );
    else setRiskAssessmentModels(uniqueModelList);
    let totalTasks = 0;
    let completedTasks = 0;
    riskAssessmentState.forEach(ra => {
      totalTasks += ra.task_detail?.length;
      completedTasks +=
        ra.task_detail?.filter(
          item => item.task_status === taskStatusIDS.completed,
        )?.length ?? 0;
    });
    if (location.state?.type === assessmentTypeIds.cybersecurity) {
      setHeading(`Cybersecurity assessments: ${riskAssessmentState.length}`);
    } else {
      setHeading(
        `Progress: ${completedTasks}/${totalTasks} ${location.state?.type === 1 ? "task" : "control system"} assessed from ${riskAssessmentState.length} ${location.state?.type === 1 ? "Risk" : "Functional safety"} assessments`,
      );
    }
  }, [riskAssessmentState]);

  const handleRiskAssessmentAction = payload => {
    dispatch(
      createRiskAssessment({
        payload,
        callback: resp => {
          if (payload.type === assessmentTypeIds.cybersecurity) {
            setShowCreateNewCybersecurityAssessment(false);
            nav(
              allRoutes.dashboardRoutes.assessmentRoutes
                .specificRiskAssessment,
              {
                state: {
                  ...location.state,
                  selectedRiskAssessment: resp?.data,
                  type: assessmentTypeIds.cybersecurity,
                },
              },
            );
            return;
          }
          fetchRiskAssessments({
            productLineId: location.state?.selectedProductLine?.id,
            modelId: location.state?.selectedModelId,
            type: type,
          });
          fetchProductLineAllRiskAssessments({
            productLineId: location.state?.selectedProductLine?.id,
          });
          setShowCreateNewRiskAssessment(false);
          setShowDuplicateRiskAssessment(false);
        },
      }),
    );
  };
  const handleEditRiskAssessmentAction = payload => {
    const id = clickedRiskAssessment?.id;
    dispatch(
      editRiskAssessment({
        id,
        payload,
        callback: resp => {
          fetchRiskAssessments({
            productLineId: location.state?.selectedProductLine?.id,
            modelId: location.state?.selectedModelId,
            type: type,
          });
          fetchProductLineAllRiskAssessments({
            productLineId: location.state?.selectedProductLine?.id,
          });
          setShowEditRiskAssessment(false);
        },
      }),
    );
  };

  const fetchRiskAssessments = ({productLineId, modelId, type}) => {
    if (modelId) {
      dispatch(
        getRiskAssessments({
          modelId: modelId,
          type,
          config: riskAssessmentConfig,
        }),
      );
    } else if (productLineId) {
      dispatch(
        getRiskAssessments({
          productLineId: productLineId,
          type,
          config: riskAssessmentConfig,
        }),
      );
    }
  };

  const fetchProductLineAllRiskAssessments = ({productLineId}) => {
    dispatch(
      getAllRiskAssessments({
        productLineId: productLineId,
        config: riskAssessmentConfig,
      }),
    );
  };

  const handleRiskAssesmentSelection = selected => {
    nav(
      `${allRoutes.dashboardRoutes.assessmentRoutes.specificRiskAssessment}`,
      {
        state: {
          ...location.state,
          selectedRiskAssessment: selected,
          type: selected.type,
        },
      },
    );
  };
  const handleRaDuplicate = data => {
    const obj = {
      data: {
        riskAssessmentName: data.name,
        accessType: riskAssessmentAccessNames[data.access],
        userAccessList: data.user_detail,
        productLine: data.product_detail,
        modelsList: data.machine_detail,
      },
      access: data.access,
    };
    setSelectedRiskAssessmentDetails(obj);
  };
  const handleRaDelete = () => {
    const id = clickedRiskAssessment?.id;
    setShowConfirmationPopUp(false);

    dispatch(
      deleteRiskAssessment({
        id,
        callback: () => {
          fetchRiskAssessments({
            productLineId: location.state?.selectedProductLine?.id,
            modelId: location.state?.selectedModelId,
            type: type,
          });
        },
      }),
    );
  };
  const handleuserEditAccess = id => {};
  const handleRaEdit = id => {};

  const handleInputChange = e => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      const obj = {...riskAssessmentConfig};
      obj.params.search = e.target.value;
      setRiskAssessmentConfig(obj);
    }, 1000);
  };

  const deleteRiskHandler = ra => {
    const deletePermission = rbac.deleteRiskAssessment(userRoleId);
    if (deletePermission) {
      setShowConfirmationForSubmitRequestPopUp(true);
    } else {
      setShowConfirmationPopUp(true);
      setClickedRiskAssessment(ra);
    }
  };

  const handleRequestSubmission = () => {
    setShowConfirmationForSubmitRequestPopUp(false);
  };

  return (
    <div className="risk-assessment-list-wrapper">
      <header>
        <div className="risk-assessment-header">
          <div className="risk-assessment-info">
            <span className="heading">{heading}</span>
            <span className="model-list">
              {riskAssessmentModels.map((model, idx) => (
                <span key={`${model.id}-${idx}`} className="model-chip">
                  {model.name}
                </span>
              ))}
            </span>
          </div>
          <div className="risk-assessment-actions">
            {rbac.newRiskAssessment(userRoleId) && (location.state?.type === 1 || !location.state?.type) && (
              <>
                <Button
                  clickHandler={() => {
                    setShowImportRiskAssessment(true)
                  }}
                  variant="secondary-button">
                  <img style={{marginRight: '8px', width: '16px', height: '16px'}} src={assets.uploadIcon} />
                  Import
                </Button>
                <Button
                  clickHandler={() => {
                    setShowCreateNewRiskAssessment(true)
                    setType(1)
                  }}
                  variant="submit-button">
                  New Risk Assessment
                </Button>
              </>
            )}
            {rbac.newRiskAssessment(userRoleId) && (location.state?.type === 2 || !location.state?.type) && (
              <>
                <Button
                  clickHandler={() => {
                    setShowImportFunctionalSafety(true)
                  }}
                  variant="secondary-button">
                  <img style={{marginRight: '8px', width: '16px', height: '16px'}} src={assets.uploadIcon} />
                  Import
                </Button>
                <Button
                  clickHandler={() => {
                    setShowCreateNewRiskAssessment(true)
                    setType(2)
                  }}
                  variant="submit-button">
                  New Functional Safety
                </Button>
              </>
            )}
            {rbac.newRiskAssessment(userRoleId) &&
              location.state?.type === assessmentTypeIds.cybersecurity &&
              location.state?.selectedModelId && (
                <Button
                  clickHandler={() => {
                    setShowCreateNewCybersecurityAssessment(true)
                  }}
                  variant="submit-button">
                  New Cybersecurity Assessment
                </Button>
              )}
          </div>
        </div>
        <div className="pl-search">
          <CustomSearch
            onChange={handleInputChange}
            width="400px"
            type="text"
          />
        </div>
      </header>

      <div className="risk-assessment-list">
        {riskAssessmentState.map(ra => (
          <RiskAssessmentCard
            key={ra.id}
            data={ra}
            handleRaDuplicate={() => {
              handleRaDuplicate(ra);
              setShowDuplicateRiskAssessment(true);
              setType(ra.type)
            }}
            handleuserEditAccess={() => handleuserEditAccess(ra)}
            handleRaDelete={() => {
              deleteRiskHandler(ra);
              setType(ra.type)
            }}
            handleRaEdit={() => {
              handleRaDuplicate(ra);
              setShowEditRiskAssessment(true);
              setClickedRiskAssessment(ra);
              setType(ra.type)
            }}
            handleRiskAssesmentSelection={handleRiskAssesmentSelection}
            hasWritePrivileges={rbac.riskAssessmentMoreActions(userRoleId)}
          />
        ))}
      </div>
      {showCreateNewRiskAssessment && (
        <NewRiskAsessment
          label={
            type == 1
              ? 'New Risk Assessment'
              : 'New Functional Safety'
          }
          show={showCreateNewRiskAssessment}
          setShow={setShowCreateNewRiskAssessment}
          handleRiskAssessmentAction={handleRiskAssessmentAction}
          assessmentType={type}
        />
      )}
      {showDuplicateRiskAssessment && (
        <NewRiskAsessment
          label={`Duplicate ${assessmentTypeNames[type]}`}
          show={showDuplicateRiskAssessment}
          prefilledData={selectedRiskAssessmentDetails}
          setShow={setShowDuplicateRiskAssessment}
          handleRiskAssessmentAction={handleRiskAssessmentAction}
          assessmentType={type}
        />
      )}
      {showEditRiskAssessment && (
        <NewRiskAsessment
          label={`Edit ${assessmentTypeNames[type]}`}
          show={showEditRiskAssessment}
          prefilledData={selectedRiskAssessmentDetails}
          setShow={setShowEditRiskAssessment}
          action="edit"
          handleRiskAssessmentAction={handleEditRiskAssessmentAction}
          assessmentType={type}
        />
      )}
      {showCreateNewCybersecurityAssessment && (
        <NewCybersecurityAssessment
          show={showCreateNewCybersecurityAssessment}
          setShow={setShowCreateNewCybersecurityAssessment}
          handleRiskAssessmentAction={handleRiskAssessmentAction}
        />
      )}
      {showImportRiskAssessment && (
        <ImportRiskAssessment
          show={showImportRiskAssessment}
          setShow={setShowImportRiskAssessment}
          productId={location.state?.selectedProductLine?.id}
          machineId={location.state?.selectedModelId}
          onImportSuccess={(response) => {
            // Refresh risk assessments list after successful import
            const productLineId = location.state?.selectedProductLine?.id;
            const modelId = location.state?.selectedModelId;
            const assessmentType = location?.state?.type;
            if (modelId) {
              fetchRiskAssessments({
                modelId,
                type: assessmentType,
                riskAssessmentConfig,
              });
            } else if (productLineId) {
              fetchRiskAssessments({
                productLineId,
                type: assessmentType,
                riskAssessmentConfig,
              });
            }
            fetchProductLineAllRiskAssessments({productLineId, riskAssessmentConfig});
          }}
        />
      )}
      {showImportFunctionalSafety && (
        <ImportFunctionalSafety
          show={showImportFunctionalSafety}
          setShow={setShowImportFunctionalSafety}
          productId={location.state?.selectedProductLine?.id}
          machineId={location.state?.selectedModelId}
          onImportSuccess={(response) => {
            // Refresh risk assessments list after successful import
            const productLineId = location.state?.selectedProductLine?.id;
            const modelId = location.state?.selectedModelId;
            const assessmentType = location?.state?.type;
            if (modelId) {
              fetchRiskAssessments({
                modelId,
                type: assessmentType,
                riskAssessmentConfig,
              });
            } else if (productLineId) {
              fetchRiskAssessments({
                productLineId,
                type: assessmentType,
                riskAssessmentConfig,
              });
            }
            fetchProductLineAllRiskAssessments({productLineId, riskAssessmentConfig});
          }}
        />
      )}
      {showConfirmationPopUp && (
        <Confirmation
          label={`Delete ${assessmentTypeNames[type]}`}
          show={showConfirmationPopUp}
          setShow={setShowConfirmationPopUp}
          confirmationType={'typeDelete'}
          primaryButtonText="Delete"
          secondaryButtonText="Cancel"
          primaryButtonClickHandler={handleRaDelete}
          secondaryButtonClickHandler={() => setShowConfirmationPopUp(false)}
        />
      )}

      {showConfirmationForSubmitRequestPopUp && (
        <Confirmation
          label={`${assessmentTypeNames[type]} Deletion Request`}
          confirmationText={`You can request the deletion of a ${assessmentTypeNames[type]?.toLowerCase()} through the Feedback form.`}
          show={showConfirmationForSubmitRequestPopUp}
          setShow={setShowConfirmationForSubmitRequestPopUp}
          primaryButtonText="OK"
          primaryButtonClickHandler={handleRequestSubmission}
        />
      )}

      {isLoading && <Loader />}
    </div>
  );
}
